import React from 'react';
import Layout from '../../components/layout';
import BrainComponent from '../../components/one-oh-one/BrainComponent';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <BrainComponent path="/one-oh-one/brain" />
    </Layout>
  );
};

export default OneOhOne;
